import React from "react";
import { useTranslation } from "react-i18next";
import { shareWaysList } from "../../constants";

export default function ShareIcons(props) {
  const { t } = useTranslation("common");

  let classNames = "share-view__links-container";

  if (typeof props.modifyingClass !== "undefined") {
    classNames = classNames + " " + props.modifyingClass;
  }

  const sharingHandler = (type) => {
    window.dataLayer?.push({
      event: "mtcExpShare",
      medium: type,
    });
  };

  const download = (event, url, filename, name) => {
    event.preventDefault();

    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "my_macallan_journey.png";
        link.click();
      })
      .then(() => this.sharingHandler(name))
      .catch(console.error);
  };

  const openPopup = (event, url) => {
    event.preventDefault();
    const myWidth = 500;
    const myHeight = 300;

    var left = (window.screen.width - myWidth) / 2;
    var top = (window.screen.height - myHeight) / 3;
    var windowData =
      "width=" +
      myWidth +
      ", height=" +
      myHeight +
      ", top=" +
      top +
      ", left=" +
      left;

    window.open(url, "popup", windowData);
  };

  const renderIcons = shareWaysList.map((shareWay) => {
    if (shareWay.name === "Save Image") {
      return (
        <li key={shareWay.name} className="share-view__link">
          <a
            title={t(shareWay.tooltip)}
            className="share-view__link-button"
            href={props.image || "#"}
            role="button"
            onClick={(event) =>
              download(event, props.image, props.image, shareWay.name)
            }
          >
            <i className={`icon-share icon-share--${shareWay.icon}`}></i>
          </a>
        </li>
      );
    } else {
      const url = shareWay.url
        .replace("IMG_URL", encodeURIComponent(props.image))
        .replace("SHARE_TEXT", encodeURI(t("journey.share_text")));
      return (
        <li key={shareWay.name} className="share-view__link">
          <a
            title={t(shareWay.tooltip)}
            className="share-view__link-button"
            onClick={(event) => {
              shareWay.name !== "Email" && openPopup(event, url);
              sharingHandler(shareWay.name);
            }}
            href={url}
          >
            <i className={`icon-share icon-share--${shareWay.icon}`}></i>
          </a>
        </li>
      );
    }
  });

  return <ul className={classNames}>{renderIcons}</ul>;
}
